import { createContext, useContext } from 'react';

/**
 * Contexto compartilhado para a instância de API e base URL.
 * Permite que useApi e useApiBaseUrl consumam a API correta conforme o fluxo (Keycloak ou Becompliance).
 * @type {React.Context<{ getApi: () => import('axios').AxiosInstance, baseURL: string }>}
 */
export const ApiContext = createContext(null);

/**
 * Retorna a base URL da API (v2 ou v3) conforme o fluxo ativo.
 * Útil para URLs hardcoded (EventSource, fetch, etc.).
 */
export const useApiBaseUrl = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error(
      'useApiBaseUrl deve ser usado dentro de ApiProvider (Keycloak) ou BeApiProvider (Becompliance)'
    );
  }
  return context.baseURL;
};
